import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'FilterCompletedgoals',
    pure: false
})
export class FilterCompletedgoals implements PipeTransform {
    transform(items: any[], filter): any {
        if (!items || !filter) {
            return items;
        }

        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => parseInt(filter, 2) === item.completed );
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/filter.completedgoals.ts